import { areDiscountItemPricesEquivalent, getItemById, getLowestItemPricesForParentSalesOptions, isDiscountItemPrice, isEmptyArray, isMemberRewardItemPrice, isNormalItem, isParentSalesItem } from '@vista/omnichannel-components-domain';
import { getLabelForDiscountItemPrice, getPromotionLabelForSellableItem } from '../../../utils/items/get-promotion-label';
export const getPromotionLabel = (sellableItem, displayText, occDisplayText, i18n) => {
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Cannot find item with ID: ${sellableItem.itemId}.`);
    if (isNormalItem(item)) {
        return getPromotionLabelForSellableItem(sellableItem, occDisplayText, i18n);
    }
    if (isParentSalesItem(item)) {
        return getPromotionLabelForParentSalesItem(item, displayText, occDisplayText, i18n);
    }
};
const getPromotionLabelForParentSalesItem = (item, displayText, occDisplayText, i18n) => {
    const lowestItemPrices = getLowestItemPricesForParentSalesOptions(item.options);
    if (isEmptyArray(lowestItemPrices))
        return;
    const discountLabel = getDiscountLabelForParentSalesItem(lowestItemPrices, displayText, occDisplayText, i18n);
    if (discountLabel)
        return discountLabel;
    if (lowestItemPrices.some(isMemberRewardItemPrice))
        return occDisplayText.member.rewardExclusiveLabel;
    return undefined;
};
const getDiscountLabelForParentSalesItem = (lowestItemPrices, displayText, occDisplayText, i18n) => {
    const allAreDiscountPrices = lowestItemPrices.every(isDiscountItemPrice);
    if (allAreDiscountPrices) {
        const itemPrices = lowestItemPrices;
        const allOptionsHaveSameDiscount = areDiscountItemPricesEquivalent(itemPrices);
        if (allOptionsHaveSameDiscount)
            return getLabelForDiscountItemPrice(itemPrices[0], occDisplayText, i18n);
    }
    const someAreDiscountPrices = lowestItemPrices.some(isDiscountItemPrice);
    if (someAreDiscountPrices)
        return displayText.parentSalesItemGenericDiscountLabel;
};
